// Contratos de autenticação. JWT de 1 h com estado no banco: o guard valida a
// assinatura E procura a sessão, para conseguir derrubar sessões (usuário
// desativado, troca de senha, logout).
import { z } from 'zod';
import { USER_ROLES } from './enums.js';
export const PASSWORD_MIN = 10;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN, `A senha precisa de pelo menos ${PASSWORD_MIN} caracteres`)
    .max(200)
    .refine((s) => /[a-zA-Z]/.test(s) && /[0-9]/.test(s), {
    message: 'A senha precisa ter letras e números',
});
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(1),
    /** Preenchido quando o usuário precisa trocar a senha antes de entrar. */
    newPassword: passwordSchema.optional(),
});
export const forgotPasswordSchema = z.object({
    email: z.string().trim().toLowerCase().email(),
});
export const resetPasswordSchema = z.object({
    token: z.string().min(16),
    password: passwordSchema,
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
});
/** Home de cada perfil — usada pelo router e pelo error boundary. */
export const HOME_BY_ROLE = {
    cliente: '/chamados',
    tecnico: '/painel/fila',
    administrador: '/gestao/dashboard',
};
